import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Store, select } from "@ngrx/store";
import { AppState } from "../../../app.state";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { IEmpresa } from "../../../interfaces/catalogos.";
import { LoadingService } from "../../../loading/loading.service";
import { EmpresaService } from "../../../services/catalogos/empresa/empresa.service";
import { showHideCatalogo } from "../../../states/admon-catalogos/actions";
import { selectCatalogoEmpresaStatus } from "../../../states/admon-catalogos/selector";
import { cargaEmpresa } from "../../../states/catalogos/actions";
import {
  campoRequerido,
  descripcionCatalogo,
  existeValorDuplicado
} from "../../utils";
import { AddEditEmpresaComponent } from "../add/add-edit.component";

@Component({
  selector: "app-list",
  standalone: true,
  imports: [
    MatCardModule,
    CommonModule,
    AddEditEmpresaComponent,
    MatButtonModule,
    MatIconModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  templateUrl: "./list.component.html",
  styleUrl: "./list.component.css",
})
export class ListEmpresaComponent {
  private store: Store<AppState> = inject(Store);
  admonCatEmpresaStatus$ = this.store.pipe(select(selectCatalogoEmpresaStatus));

  empresas: IEmpresa[] = [];
  registroSeleccionado!: IEmpresa | null;
  ocultarVistaLectura = false;
  editandoRegistro = false;
  mostrarBotones = true;
  editarForm!: FormGroup;
  cerrarEdicion = false;
  existe = false;

  constructor(
    private empresaService: EmpresaService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public loadingService: LoadingService
  ) {}

  ngOnInit(): void {
    this.loadingService.show();
    this.editarForm = this.fb.group({
      descripcion: [
        "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          descripcionCatalogo(),
          campoRequerido(),
        ],
      ],
    });
    this.loadEmpresas();
  }

  loadEmpresas() {
    this.empresaService.cargarEmpresas().subscribe(
      (response) => {
        this.empresas = response;
        console.log("Empresas cargadas:", this.empresas);
        this.loadingService.hide();
        // Realizar otras acciones después de cargar las empresas
        console.log("Cargamos empresas en app store");
        this.store.dispatch(cargaEmpresa({ catEmpresa: response }));
      },
      (error) => {
        this.loadingService.hide();
        console.error("Error al cargar empresas:", error);
        // Manejar el error de carga de empresas
      }
    );
  }

  editarRegistro(empresa: IEmpresa | null): void {
    this.registroSeleccionado = empresa;

    this.editarForm = this.fb.group({
      descripcion: [
        empresa?.descripcion || "",
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
          descripcionCatalogo(),
          campoRequerido(),
        ],
      ],
    });
    this.editarForm.markAllAsTouched();
    console.log("control", this.editarForm.get("descripcion"));

    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "empresas",
        mostrarEditar: true,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  cancelarEdicion() {
    this.editandoRegistro = false;
    this.editarForm.setValue({
      descripcion: "",
    });

    this.store.dispatch(
      showHideCatalogo({
        tipoCatalogo: "empresas",
        mostrarEditar: false,
        mostrarNuevo: false,
        guardando: false,
      })
    );
  }

  ocultarBotones(value: boolean) {
    console.log("value ", value);

    this.mostrarBotones = value;
    this.editandoRegistro = value;
    this.registroSeleccionado = null;
  }

  guardarCambios(data: IEmpresa) {
    this.loadingService.show();
    if (this.editarForm.valid) {
      this.empresaService
        .editarEmpresa({
          ...data,
          descripcion: this.editarForm.value.descripcion,
        })
        .subscribe((data) => {
          if (!data.error) {
            this.store.dispatch(
              showHideCatalogo({
                tipoCatalogo: "empresas",
                mostrarEditar: false,
                mostrarNuevo: false,
                guardando: false,
              })
            );
          }
          this.loadEmpresas();
          this.loadingService.hide();
        });
    }
  }
  eliminarEmpresa(empresa: IEmpresa): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title: "Advertencia",
        message: "¿Estás seguro que quieres eliminar el elemento?",
        showButtons: {
          accept: true,
          cancel: true,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "CONFIRMAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      // Lógica para confirmar la acción
      console.log("Acción confirmada");

      this.empresaService
        .consultarTemasPorEmpresa(empresa.id)
        .subscribe((data) => {
          console.log("consultarTemasPorEmpresa data", data);

          if (data.error) {
            this.dialog.open(ConfirmDialogComponent, {
              width: "450px",
              data: {
                title: "Importante",
                message: data.message.msg,
                showButtons: {
                  accept: true,
                  cancel: false,
                },
                direction: "end",
                buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
              },
            });
            this.loadingService.hide();
          } else if (!data.error) {
            console.log("error", data);
            this.empresaService
              .eliminarEmpresa(empresa.id)
              .subscribe((data) => {
                this.loadingService.hide();
                this.loadEmpresas();
              });
          }
        });
    });

    dialogRef.componentInstance.cancelAction.subscribe(() => {
      // Lógica para cancelar la acción
      console.log("Acción cancelada");
      this.loadingService.hide();
    });
  }

  existeRegistro(control: any, currentValue: any) {
    existeValorDuplicado(control, this.empresas, currentValue);
  }
}
